// extracted by mini-css-extract-plugin
module.exports = {"cell":"CallListThead_cell__2zl5K"};